import React from "react";
import { BadgeCheckIcon, QuoteIcon, StarIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { SectionHeading } from "../SectionHeading";
import { testimonials } from "../../data/testimonials";
function Stars() {
  return <div className="flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-301" data-mp="3mepjurjhftqe">
      {Array.from({
      length: 5
    }).map((_, i) => <StarIcon key={i} className="h-5 w-5 fill-sun text-sun" aria-hidden="true" data-id="element-302" data-mp="3r9bu2rdtvg8w" data-mpi={i} />)}
    </div>;
}
export function Testimonials() {
  const [featured, ...rest] = testimonials;
  return <section className="bg-brand-soft px-4 py-16 sm:py-20" data-id="element-303" data-mp="44nlqk1ns9py">
      <div className="mx-auto max-w-5xl" data-id="element-304" data-mp="92ffljlv65ws">
        <SectionHeading eyebrow="What other professionals are saying" title="Real Feedback From Professionals Like You." data-id="element-305" data-mp="e0z1jk0gjhp5" />
        <div className="mt-4 flex items-center justify-center gap-2" data-id="element-306" data-mp="2aukddbq1nxff">
          <Stars data-id="element-307" data-mp="2fru4cvt30h5d" />
          <span className="text-sm font-black text-navy" data-id="element-308" data-mp="2ftezamjb623r">Rated 5 stars by communication professionals</span>
        </div>

        <figure className="mt-10 overflow-hidden rounded-3xl bg-white shadow-[0_10px_30px_rgba(14,37,87,0.08)] md:grid md:grid-cols-[18rem_1fr]" data-id="element-309" data-mp="1slu6q8nfk1ah">
          <img src={featured.image} alt={featured.name} className="aspect-square w-full object-cover md:h-full" data-id="element-310" data-mp="1iug9y8mv5fl1" />
          <div className="p-6 sm:p-8" data-id="element-311" data-mp="1etxjahwpifkf">
            <QuoteIcon className="h-9 w-9 text-brand" aria-hidden="true" data-id="element-312" data-mp="1euz43e3iygfc" />
            <blockquote className="mt-3 text-xl font-bold leading-relaxed text-navy sm:text-2xl" data-id="element-313" data-mp="2bi3tdkcee063">
              “{featured.quote}”
            </blockquote>
            <figcaption className="mt-5" data-id="element-314" data-mp="22ip6svzcq9qv">
              <Stars data-id="element-315" data-mp="22hdzim6p6jv0" />
              <p className="mt-2 flex items-center gap-1.5 text-lg font-black text-navy" data-id="element-316" data-mp="22gvxf8xctbf6">
                {featured.name}
                <BadgeCheckIcon className="h-5 w-5 text-brand" aria-label="Verified customer" data-id="element-317" data-mp="r3jzfeo9zn0x" />
              </p>
              <p className="text-sm font-bold text-ink/65" data-id="element-318" data-mp="m4qitddozfwj">
                {featured.role} · {featured.country}
              </p>
            </figcaption>
          </div>
        </figure>

        <div className="mt-5 grid gap-5 sm:grid-cols-2" data-id="element-319" data-mp="skpc4n0k57gf">
          {rest.map(t => <figure key={t.name} className="flex flex-col rounded-3xl bg-white p-6 shadow-[0_10px_30px_rgba(14,37,87,0.06)]" data-id="element-320" data-mp="sicygm1u1j96">
              <Stars data-id="element-321" data-mp="im05jqe439fh" />
              <blockquote className="mt-4 text-base font-semibold leading-relaxed text-ink" data-id="element-322" data-mp="ili1w8p4dsxj">“{t.quote}”</blockquote>
              <figcaption className="mt-auto flex items-center gap-3 pt-5" data-id="element-323" data-mp="4tjy8de6gp8r">
                <img src={t.image} alt={t.name} className="h-14 w-14 shrink-0 rounded-full object-cover ring-4 ring-brand-soft" data-id="element-324" data-mp="9m4sfg0zx4ct" />
                <div data-id="element-325" data-mp="3r461obqqaj6f">
                  <p className="flex items-center gap-1.5 font-black text-navy" data-id="element-326" data-mp="3r0i85cla9wrp">
                    {t.name}
                    <BadgeCheckIcon className="h-4 w-4 text-brand" aria-label="Verified customer" data-id="element-327" data-mp="3i1obxnbv78eo" />
                  </p>
                  <p className="text-sm font-bold text-ink/65" data-id="element-328" data-mp="3n19gqedpuazb">
                    {t.role} · {t.country}
                  </p>
                </div>
              </figcaption>
            </figure>)}
        </div>

        <p className="mt-12 text-center text-2xl font-black uppercase text-navy" data-id="element-329" data-mp="2yh6bp7z2wtfe">Ready to explore the complete collection?</p>
        <div className="mt-6" data-id="element-330" data-mp="3cgyvskg3obee">
          <CtaButton label="Get Autism Communication Support Blueprint™ for $27" sub="Secure Checkout · One-Time Payment" data-id="element-331" data-mp="38eao4g34haj0" />
        </div>
      </div>
    </section>;
}